<template>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isDisabledModification">
        <Button label="Modifier" disabled=true />
      </div>
      <div v-else>
        <Button label="Modifier" v-on:click="modifier" />
      </div>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['fermer'],
  data() {
    return{
      isDisabledModification: true,
    };
  },
  methods: {
    modifier() {
      this.$router.push({
        name: "modifierConsignation",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
        },
      });
    },
    fermer() {
      this.$emit('fermer');
    },
    setModificationDisponible(isModifiable){
      this.isDisabledModification = isModifiable !== false;
    },
  }
}

</script>